import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import {useHistory, useParams} from 'react-router-dom';

import { UserService } from '../../services/UserService';
import useRequest from '../../hooks/useRequest';

import MainLayout from '../../components/Layouts/MainLayout';

import ChangePassword from 'components/atoms/ChangePassword';


import './styles.scss';
import LoginHeader from "../../components/atoms/LoginHeader";
import {isMobile} from "../../helpers/Mobile";
import FooterMobile from "../../components/atoms/FooterMobile";
import SpinnerAbsa from 'components/atoms/SpinnerAbsa';

const ResetPasswordView = (props) => {
    const history = useHistory();
    const { token } = useParams();

    const {
        beforeSubmit, afterSubmit, errors,
        dealWithError
    } = useRequest();

    const handleSubmit = (passwordData) => {
        beforeSubmit();
        console.log('va');
        const data = {
            password: passwordData.password,
            password_confirmation: passwordData.password_confirmation,
            token : token
        }

        UserService.resetConfirm(data)
            .then(data => {
                afterSubmit();
                history.push('/confirmar_password');
            }).catch((error) => {
                dealWithError(error, 'Error al cambiar la contraseña');
            });
    }

    return (
        <div className="created-account-container">
            <LoginHeader></LoginHeader>
            <ChangePassword handleSubmit={handleSubmit} error={errors}></ChangePassword>
            {isMobile && <FooterMobile></FooterMobile>}
            <SpinnerAbsa></SpinnerAbsa>
        </div>
    );
}

export default withTranslation()(ResetPasswordView);